import { CanvasBlockRenderer } from "../CanvasBlockRenderer";
import { type CanvasBlock } from "../types";

interface GridBlockProps {
  columns: number;
  children: CanvasBlock[];
  onSectionClick?: (sectionId: string, title: string) => void;
  onBadgeAction?: (action: string, label: string) => void;
}

export function GridBlock({
  columns,
  children,
  onSectionClick,
  onBadgeAction,
}: GridBlockProps) {
  const gridClass =
    {
      1: "grid-cols-1",
      2: "grid-cols-1 @sm:grid-cols-2",
      3: "grid-cols-1 @sm:grid-cols-2 @lg:grid-cols-3",
      4: "grid-cols-1 @sm:grid-cols-2 @lg:grid-cols-4",
    }[columns] ?? "grid-cols-1 @sm:grid-cols-2";

  return (
    <div className="@container">
      <div className={`grid ${gridClass} gap-4`}>
        {(children ?? []).map((child, idx) => (
          <CanvasBlockRenderer
            key={idx}
            block={child}
            onSectionClick={onSectionClick}
            onBadgeAction={onBadgeAction}
          />
        ))}
      </div>
    </div>
  );
}
